import { render, staticRenderFns } from "./user-show.vue?vue&type=template&id=62856b19&scoped=true&"
import script from "./user-show.vue?vue&type=script&lang=js&"
export * from "./user-show.vue?vue&type=script&lang=js&"
import style0 from "./user-show.vue?vue&type=style&index=0&id=62856b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62856b19",
  null
  
)

export default component.exports